import React, { useState, useEffect } from 'react';
import cn from 'clsx';
import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

// import Section from './Faq.styled';
import { faqDataCommon } from '../../utils/contentProvider/faqDataCommon';
import { btnOnClick } from '../../utils/contentProvider/function';

import {
  MixPanelEvents,
  MixPanelButtons,
  MixPanelButtonContext,
  PostHogEvents,
  PostHogButtons,
  PostHogButtonContext,
} from '../../constants';
import 'styles/components/Faq.scss';

const Faq = ({ data, limitFaq, headingCTA, toggleContactUs, greyBg }) => {
  const [showFaq, setShowFaq] = useState(0);

  function showFaqClick() {
    setShowFaq((state) => !state);
  }

  useEffect(() => {
    if (limitFaq) {
      setShowFaq(1);
    }
  }, []);
  return (
    <section className={cn(['faq-section', { greyBg }])}>
      <div className="faq-home" id="faq">
        <div className="container">
          <div className="flex flex-wrap">
            <div className="faq-heading-area">
              {headingCTA ? (
                <div className="sticky-heading">
                  <h2 className="heading">FAQ</h2>
                  <p>
                    Please check if your question has been answered here before
                    emailing us! We&apos;d love to chat, but this saves our time
                    and yours!
                  </p>
                  <button
                    type="button"
                    className="button"
                    onClick={toggleContactUs}>
                    I have more questions
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 512 512">
                      <path
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="48"
                        d="M268 112l144 144-144 144M392 256H100"></path>
                    </svg>
                  </button>
                </div>
              ) : (
                <h2 className="heading">Frequently Asked Questions</h2>
              )}
            </div>

            <div className="faq-question-main">
              <Accordion preExpanded={[0]} allowZeroExpanded>
                {(data || faqDataCommon).map(
                  ({ q, a, uuid = nanoid() }, id) => (
                    <AccordionItem
                      uuid={id}
                      key={uuid}
                      className={`faq-single ${
                        showFaq && id > 6 ? 'hidden-faq' : ''
                      }`}>
                      <AccordionItemHeading className="question center">
                        <AccordionItemButton>
                          <h3>{q}</h3>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel className="answer">
                        {a}
                      </AccordionItemPanel>
                    </AccordionItem>
                  ),
                )}
                <button
                  className={`button ${limitFaq ? '' : 'hidden'}`}
                  type="button"
                  onClick={btnOnClick({
                    mixPanelEvent: MixPanelEvents.ButtonClick,
                    posthogEvent: PostHogEvents.ButtonClick,
                    config: {
                      Button: MixPanelButtons.ViewMore,
                      Context: MixPanelButtonContext.FaqViewMore,
                    },
                    posthogConfig: {
                      Button: PostHogButtons.ViewMore,
                      Context: PostHogButtonContext.FaqViewMore,
                    },
                    callback: showFaqClick,
                  })}>
                  {showFaq ? 'View more' : 'View less'}
                </button>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
Faq.defaultProps = {
  data: null,
  limitFaq: null,
  headingCTA: false,
  toggleContactUs: () => {},
  greyBg: false,
};

Faq.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      uuid: PropTypes.string,
      q: PropTypes.string,
      a: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    }),
  ),
  limitFaq: PropTypes.bool,
  headingCTA: PropTypes.bool,
  toggleContactUs: PropTypes.func,
  greyBg: PropTypes.bool,
};

export default Faq;
